import { Flex, Loader } from "@fluentui/react-northstar";

import { loaderWithProviderStyles } from "./FullParentLoader.styles";

export const FullParentLoader: React.FC = () => {
  return (
    <Flex fill styles={loaderWithProviderStyles}>
      <Loader data-testid="fullParentLoader" />
    </Flex>
  );
};
